"use client";

import { Box } from "@mui/material";

interface VideoProps {
  src: string;
  autoplay?: boolean;
  loop?: boolean;
  muted?: boolean;
  controls?: boolean;
  width?: string;
  height?: string;
}

export const Video = ({
  src,
  autoplay = true,
  loop = true,
  muted = true,
  controls = false,
  width = "100%",
  height = "auto",
}: VideoProps) => {
  return (
    <Box
      component="video"
      src={src}
      autoPlay={autoplay}
      loop={loop}
      muted={muted}
      controls={controls}
      playsInline
      preload="none"
      sx={{
        width,
        height,
        maxWidth: "100%",
        display: "block",
      }}
    />
  );
};
